module.exports = __webpack_public_path__ + "static/media/image-2.d938a131.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Catalog/image-2.png
// module id = 259
// module chunks = 0